//
import { List, Record } from 'immutable';

export const mkAlertDialogProps = Record({
  title: 'Alert',
  content: '',
  onClose: null,
  buttons: List(['Yes', 'No']),
  paperStyle: null,
  rootStyle: null,
  titleIcon: null,
  showCloseButton: false,
  tertiaryButton: '',
});

export const DIALOG_TYPE = 'DIALOG_ALERT';
